import { replacements } from './variableReplacements';

export function replacePersonVariablesWrap(observationTitle, child, adult) {
    return this.replacePersonVariables(observationTitle, child, adult, true);
}

export function replacePersonVariables(text, child, adult, wrap = false) {
    text = text.replace(/%(.+?)([\+\-]\d+)?%/g, (replaceString, variableName, variableModifier) => {
        if (!replacements.hasOwnProperty(variableName)) {
            //console.log(`replacement ${variableName} not found!`);

            return replaceString; // Just return the raw string - we could not replace it
        }

        let replaceCallback = replacements[variableName];

        let replaceResult = replaceCallback(child, adult, variableModifier);

        if (!replaceResult) {
            //console.log(`replaceResult for ${variableName} was falsy!`, replaceCallback, child, adult);

            return replaceString;
        }

        if (wrap) {
            replaceResult = '{{' + wrap + '}}';
        }

        //console.log(variableName, 'replacement', replaceResult);

        return replaceResult;
    });

    // Fix capitalization in the start of words
    text = text.replace(/(?<=(?:^|\.|:)\s+)([a-z])/g, (match) => {
        return match.toUpperCase();
    });

    return text;
}
